import ProviderCampaignList from './components/ProviderCampaignList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
  loadCampaign,
  loadCampaigns,
  loadArchivedCampaigns,
  loadBrands,
  resumeCampaign,
  suspendCampaign,
  deleteCampaign,
  archiveCampaign,
  revertCampaignToDraft,
  duplicateCampaign,
  extendCampaign
} from '../../shared/redux/entities/actions';

import {
  loadKPIsForAllCampaigns
} from '../../shared/redux/kpis/actions';


function getCampaigns(state, props){
  let campaigns = values(state.entities.campaigns)
  if (props.brandId){
    campaigns = campaigns.filter((c) => c.companyId === props.brandId)
  }
  return campaigns
    .sort((a,b) => {
      const statusCompare = (a.status || '').localeCompare((b.status || '')),
        nameCompare = (a.name || '').localeCompare((b.name || ''));

      return statusCompare === 0 ? nameCompare : statusCompare;
    })
    .map((c) => {
      c.name = c.name || 'Untitled campaign';
      c.budgetSpent = get(state,['kpis','campaigns',c.id,'budgetSpent'],0) || 0;
      c.numCompletions = get(state,['kpis','campaigns',c.id,'numCompletions'],0) || 0;
      c.averageRating = get(state,['kpis','campaigns',c.id,'averageRating'],0) || 0;
      c.totalCtaClickCount = get(state,['kpis','campaigns',c.id,'totalCtaClickCount'],0);
      c.ctRate = c.numCompletions ? (c.totalCtaClickCount / c.numCompletions) * 100 : 0;
      c.brandName = get(state,['entities','companies',c.companyId,'name'],'Unknown brand') || 'Unknown brand';
      c.isOrHasBeenLive = ['active','complete','suspended','outOfFunds'].indexOf(c.status) >= 0;

      return c;
    })
}

function mapStateToProps(state,props){
  return {
    campaigns:getCampaigns(state,props),
    campaignKPIs:values(state.kpis.campaigns),
    brands:values(state.entities.companies),
    preSelectedBrand: get(state,['entities','companies',props.brandId],{})
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadKPIsForAllCampaigns,
    loadCampaign,
    loadCampaigns,
    loadArchivedCampaigns,
    loadBrands,
    resumeCampaign,
    suspendCampaign,
    deleteCampaign,
    revertCampaignToDraft,
    duplicateCampaign,
    archiveCampaign,
    extendCampaign
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ProviderCampaignList));



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignList/index.js